import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useTeamForTeamClientId(teamClientId) {
    const [team, setTeam] = useState(null);
    const [loading, setLoading] = useState(true);
    const [teamId, setTeamId] = useState(null);

    useEffect(() => {
        setLoading(true);
        // Subscribe to the progress collection in Firestore
        if (!teamClientId) {
            setLoading(false);
            return;
        }

        const db = firebase.firestore();
        const ref = db.collection('teams')
            .where('teamClientId', '==', teamClientId)
            .limit(1);

        const unsubscribe = ref.onSnapshot((snapshot) => {
            const teamData = snapshot.docs[0].data();
            const teamId = snapshot.docs[0].id;
            setTeam(teamData);
            setTeamId(teamId);
            setLoading(false);
        });

        // Clean up the subscription on component unmount
        return () => {
            unsubscribe();
            setLoading(false);
        };
    },
        [teamClientId]
    );

    return [loading, team, teamId];
}
